import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import * as apiConfig from "../../api/config";
import UserAvatar from 'react-user-avatar';
import * as moment from "moment";
import "./RouteCardView.css";


function RouteCardView({
    routes,
    user,
    viewMode
}) {

    function getRouteCategoryBadge(category) {
        switch (category) {
            case "Road":
                return "/resources/images/road75.png";
            case "OffRoad":
                return "/resources/images/mtb75.png";
            case "Gravel":
                return "/resources/images/gravel75.png";
            default:
                return "/resources/images/road75.png"
        }

        //"/resources/images/mtbbadge.png"
        //"/resources/images/roadbadge.png"
    }

    return (
        <div className="profile-results float-left">
            {routes.results.length === 0 ?
                <div className="empty-message">
                    <span className="fas fa-route empty-icon"></span>
                    <div className="empty-text">No Routes Found!</div>
                </div>
                :

                <div className="card-deck route-card-view">
                    {
                        routes.results.map((route, index) => {
                            return (
                                <React.Fragment key={route.routeId}>

                                    <div className="card mb-4">
                                        <Link to={"/routes/" + route.routeId}>
                                            <img src={getRouteCategoryBadge(route.category)} className="route-badge" alt={route.category} />
                                            <img className="card-img-top img-fluid" src={`${apiConfig.API_URL}routes/routepreview/${route.routeId}.png`} alt="Card image cap" />
                                            <div className="card-body">
                                                <div className="card-title" title={route.name}>{route.name}</div>
                                                <ul className="card-text">
                                                    <li className="text-muted">Distance: {user.preferredMeasurementUnits == 'Statute' ? `${Math.round((route.totalDistanceKm * 0.621371192) * Math.pow(10, 2)) / Math.pow(10, 2)}mi` : `${Math.round(route.totalDistanceKm * Math.pow(10, 2)) / Math.pow(10, 2)}km`}</li>
                                                    <li className="text-muted">Elevation: {user.preferredMeasurementUnits == 'Statute' ? `${Math.round((route.totalElevation * 3.2808399) * Math.pow(10, 2)) / Math.pow(10, 2)}ft` : `${Math.round(route.totalElevation * Math.pow(10, 2)) / Math.pow(10, 2)}m`}</li>
                                                </ul>
                                            </div>
                                            {
                                                (() => {
                                                    switch (viewMode) {
                                                        case "bookmarks":
                                                            return (
                                                                <div className="card-footer">
                                                                    <div className="card-footer-avatar">
                                                                        {(user.id && user.id.toUpperCase() == route.ownerId.toUpperCase()) ?
                                                                            <UserAvatar size="30" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                            :
                                                                            <UserAvatar size="30" name={`${route.ownerFirstName} ${route.ownerSurname}`} src={route.ownerHasAvatar ? `${apiConfig.API_URL}user/avatar/${route.ownerId}.png` : ""} />
                                                                        }
                                                                    </div>
                                                                    <ul>
                                                                        <li className="text-muted">{`Uploaded by ${route.ownerFirstName} ${route.ownerSurname}`}</li>
                                                                        <li className="text-muted"> {`on ${moment(route.dateUploaded).format("DD/MM/YYYY")}`}</li>
                                                                    </ul>
                                                                </div>
                                                            )
                                                        case 'grouproutes':
                                                            return (
                                                                <div className="card-footer">
                                                                    <div className="card-footer-avatar">
                                                                        {(user.id && user.id.toUpperCase() == route.sharedById.toUpperCase()) ?
                                                                            <UserAvatar size="30" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                            :
                                                                            <UserAvatar size="30" name={`${route.sharedByFirstName} ${route.sharedBySurname}`} src={route.sharedByHasAvatar ? `${apiConfig.API_URL}user/avatar/${route.sharedById}.png` : ""} />
                                                                        }
                                                                    </div>
                                                                    <ul>
                                                                        <li className="text-muted">{`Shared by ${route.sharedByFirstName} ${route.sharedBySurname}`}</li>
                                                                        <li className="text-muted"> {`on ${moment(route.sharedOn).format("DD/MM/YYYY")}`}</li>
                                                                    </ul>
                                                                </div>
                                                            )
                                                        default:
                                                            return (
                                                                <div className="card-footer">
                                                                    <ul>
                                                                        <li className="text-muted">{`Uploaded on ${moment(route.dateUploaded).format("DD/MM/YYYY")}`}</li>
                                                                    </ul>
                                                                </div>
                                                            )
                                                    }
                                                })()
                                            }
                                        </Link>
                                    </div>
                                    {
                                        (index + 1) % 2 === 0 ?
                                            <React.Fragment>
                                                <div className="w-100 d-none d-sm-block d-md-none"></div>
                                                <div className="w-100 d-none d-md-block d-lg-none"></div>
                                            </React.Fragment> : ''

                                    }
                                    {
                                        (index + 1) % 3 === 0 ?
                                            <React.Fragment>
                                                <div className="w-100 d-none d-lg-block d-xl-none"></div>
                                            </React.Fragment> : ''

                                    }
                                    {
                                        (index + 1) % 4 === 0 ?
                                            <React.Fragment>
                                                <div className="w-100 d-none d-xl-block"></div>
                                            </React.Fragment> : ''
                                    }
                                </React.Fragment>
                            );
                        })}
                </div>
            }

        </div>

    );
}

RouteCardView.propTypes = {
    routes: PropTypes.object.isRequired
};

export default RouteCardView; 




// WEBPACK FOOTER //
// ./src/components/routes/RouteCardView.js